import type { QueryHookResult } from '@change-corgi/core/react/async';
import { useQuery } from '@change-corgi/core/react/async';

import { useAutocompleteService } from 'src/app/shared/hooks/googlePlaces';
import { useLocale } from 'src/app/shared/hooks/l10n';

import { getPlacePredictions } from '../api/getPlacePredictions';
import type { GeoScope, Place } from '../shared/types';

// TODO make this a bit more generic so it can be used in different ways (like by admin/decisionMakerEdit)
export function usePlacePredictions({
	input,
	geoScope,
	inputLengthApiCallThreshold,
}: {
	input: string;
	geoScope?: GeoScope;
	inputLengthApiCallThreshold?: number;
}): UsePlacePredictionsResult {
	const locale = useLocale();
	const autocompleteService = useAutocompleteService();

	return useQuery(
		async () => ({
			data: await getPlacePredictions({ input, locale, geoScope }, autocompleteService, inputLengthApiCallThreshold),
		}),
		[input, autocompleteService, locale, geoScope, inputLengthApiCallThreshold],
		{
			loadingBetweenQueries: false,
		},
	);
}

export type UsePlacePredictionsResult = QueryHookResult<{ data: Place[] }>;
